module.exports = "/images/9fd5d7322cdacd7dc7a7c6a0e5c13cea.svg";